import React from 'react';

const CATEGORIES = ['Alle', 'Nyheter', 'Veioppdateringer', 'Tips & Råd', 'Teknologi', 'Sikkerhet'];
const DATE_FILTERS = [
  { label: 'Alle tider', value: 'all' },
  { label: 'Siste måned', value: 'month' },
  { label: 'Siste 3 måneder', value: '3months' },
  { label: 'Dette året', value: 'year' }
];

const CategoryFilter = ({ activeCategory, onCategoryChange, activeDateFilter, onDateFilterChange, totalCount }) => {
  return (
    <section style={{ padding: '0 6% 48px', background: '#050A12', position: 'sticky', top: '72px', zIndex: 50, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ maxWidth: '1400px', paddingTop: '24px' }}>
        {/* Category tags */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
          <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: 'rgba(238,240,242,0.4)', letterSpacing: '0.2em', textTransform: 'uppercase', marginRight: '4px' }}>Kategori:</span>
          {CATEGORIES?.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange?.(cat)}
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                padding: '6px 14px',
                border: activeCategory === cat ? '2px solid #3B6FD4' : '2px solid rgba(255,255,255,0.12)',
                background: activeCategory === cat ? '#3B6FD4' : 'transparent',
                color: activeCategory === cat ? '#EEF0F2' : 'rgba(238,240,242,0.55)',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                transform: cat === 'Alle' ? 'rotate(0deg)' : `rotate(${(CATEGORIES?.indexOf(cat) % 2 === 0 ? -0.5 : 0.5)}deg)`
              }}
              onMouseEnter={e => { if (activeCategory !== cat) { e.currentTarget.style.borderColor = 'rgba(59,111,212,0.5)'; e.currentTarget.style.color = '#EEF0F2'; } }}
              onMouseLeave={e => { if (activeCategory !== cat) { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = 'rgba(238,240,242,0.55)'; } }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Date filter + count */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: 'rgba(238,240,242,0.4)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Periode:</span>
            {DATE_FILTERS?.map((filter) => (
              <button
                key={filter?.value}
                onClick={() => onDateFilterChange?.(filter?.value)}
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.8rem',
                  fontWeight: activeDateFilter === filter?.value ? 600 : 400,
                  padding: '4px 12px',
                  border: 'none',
                  background: 'transparent',
                  color: activeDateFilter === filter?.value ? '#A8C4F0' : 'rgba(238,240,242,0.45)',
                  cursor: 'pointer',
                  borderBottom: activeDateFilter === filter?.value ? '2px solid #3B6FD4' : '2px solid transparent',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={e => { e.currentTarget.style.color = '#EEF0F2'; }}
                onMouseLeave={e => { e.currentTarget.style.color = activeDateFilter === filter?.value ? '#A8C4F0' : 'rgba(238,240,242,0.45)'; }}
              >
                {filter?.label}
              </button>
            ))}
          </div>
          <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.85rem', color: 'rgba(238,240,242,0.4)' }}>
            {totalCount} {totalCount === 1 ? 'artikkel' : 'artikler'}
          </span>
        </div>
      </div>
    </section>
  );
};

export default CategoryFilter;
